import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');

// URL //
const eachUrl = 'township_group/getEach?';
const allUrl = 'township_group/get?';
const storeUrl = 'township_group/store';
const updateUrl = 'township_group/update?';
const deleteUrl = 'township_group/delete?';

const state = {
  townshipGroups: [],
  townshipGroup: {},
};
const getters = {};
const mutations = {
  SET_TOWNSHIP_GROUPS(state, payload) {
    state.townshipGroups = payload.data.data;
  },
  SET_TOWNSHIP_GROUP(state, payload) {
    state.townshipGroup = payload.data.data;
  },
  ADD_TOWNSHIP_GROUP(state, payload) {
    state.townshipGroups.push(payload.data.data);
  },
  REMOVE_TOWNSHIP_GROUP(state, payload) {
    const townshipGroups = state.townshipGroups.filter(
      (item) => item.id != payload.id
    );
    state.townshipGroups = [...townshipGroups];
  },
};

const actions = {
  async getTownshipGroups({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_TOWNSHIP_GROUPS", response);
  },
  async getTownshipGroup({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_TOWNSHIP_GROUP", response);
  },
  async createTownshipGroup({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_TOWNSHIP_GROUP", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async updateTownshipGroup(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async deleteTownshipGroup({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_TOWNSHIP_GROUP", payload);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
